import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Privacy from './pages/Privacy';
import About from './pages/About';
import DeleteRequest from './pages/DeleteRequest';
import Contact from './pages/Contact';
import AppRedirect from './pages/AppRedirect';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/about" element={<About />} />
        <Route path="/delete-request" element={<DeleteRequest />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/app" element={<AppRedirect />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
